{
  "schemaVersion": "cogo.ux-pattern-definition.v1",
  "uxPatternId": "newsletter-member-content",
  "version": "1.0.0",
  "target": "web",
  "intent": "Open a member briefing",
  "actorContext": "newsletter-reader",
  "requiredCapabilities": ["open-member-content", "read-content-items"],
  "preconditions": ["member-joined"],
  "postconditions": ["content-opened"],
  "states": [
    { "stateId": "locked", "statusIntent": "idle" },
    { "stateId": "open", "statusIntent": "success" }
  ],
  "transitions": [
    {
      "transitionId": "open",
      "fromState": "locked",
      "eventRef": "open-content",
      "toState": "open",
      "effectRefs": ["record-welcome-journey"],
      "emitEventRefs": ["member-content-opened"]
    }
  ],
  "ports": [
    { "portId": "open-content", "kind": "event", "direction": "in", "valueType": "cogo.content-item-id", "required": false },
    { "portId": "member-content-opened", "kind": "event", "direction": "out", "valueType": "cogo.content-item-id", "required": true }
  ],
  "semanticNodes": [
    {
      "nodeId": "content-catalog",
      "semanticRole": "content-catalog",
      "regionRef": "roster",
      "content": { "title": "Member briefings" },
      "visibleIn": ["locked", "open"]
    },
    {
      "nodeId": "open-content",
      "semanticRole": "primary-action",
      "regionRef": "decision",
      "content": { "label": "Open briefing" },
      "visibleIn": ["locked"],
      "action": { "role": "primary", "capabilityRef": "open-member-content", "slotRef": "decision-primary" }
    }
  ],
  "lineage": {
    "authorityStatus": "consumer-verified",
    "sourceKind": "human-authored-canonical",
    "sourceRefs": ["cogo:approved-source/newsletter-member-content-v1"]
  }
}
